import { DealGroup, FunActivity } from './header-client.types'

export const DEFAULT_DEAL_GROUPS: DealGroup[] = [
    {
        groupTitle: 'Lifestyle & Retail',
        items: [
            {
                title: 'Fashion & Lifestyle',
                slug: 'fashion-lifestyle',
                description:
                    'Clothing, footwear, watches, jewelry and accessories',
                icon: 'lucideSparkles',
                image: 'assets/images/categories/fashion.png',
            },
            {
                title: 'Shopping & Retail',
                slug: 'shopping-retail',
                description:
                    'Department stores, supermarkets and gift boutiques',
                icon: 'lucideStore',
                image: 'assets/images/categories/shopping.png',
            },
            {
                title: 'Electronics & Gadgets',
                slug: 'electronics-gadgets',
                description:
                    'Smartphones, computers, audio and smart home gear',
                icon: 'lucideGlobe',
                image: 'assets/images/categories/electronics.png',
            },
        ],
    },
    {
        groupTitle: 'Dining & Leisure',
        items: [
            {
                title: 'Food & Dining',
                slug: 'food-dining',
                description: 'Restaurants, artisan cafes, bakeries and bistros',
                icon: 'lucideShoppingBag',
                image: 'assets/images/categories/food.png',
            },
            {
                title: 'Entertainment',
                slug: 'entertainment',
                description: 'Cinemas, live events, amusement and theme parks',
                icon: 'lucidePartyPopper',
                image: 'assets/images/categories/entertainment.png',
            },
            {
                title: 'Travel & Leisure',
                slug: 'travel-leisure',
                description:
                    'Hotels, luxury resorts, airlines and vacation packages',
                icon: 'lucideGlobe',
                image: 'assets/images/categories/travel.png',
            },
        ],
    },
    {
        groupTitle: 'Services & Benefits',
        items: [
            {
                title: 'Health & Fitness',
                slug: 'health-fitness',
                description:
                    'Gyms, wellness clinics, medical diagnostics and spas',
                icon: 'lucideHeart',
                image: 'assets/images/categories/health.png',
            },
            {
                title: 'Banking & Finance',
                slug: 'banking-finance',
                description:
                    'Exclusive credit cards, cashback and insurance perks',
                icon: 'lucideCreditCard',
                image: 'assets/images/categories/banking.png',
            },
        ],
    },
]

export const DEFAULT_FUN_ACTIVITIES: FunActivity[] = [
    {
        title: 'Raffle & Lucky Draws',
        description:
            'Enter exciting draws, win premium gifts, and track current winning tickets.',
        icon: 'lucideTrophy',
        primaryLink: '/client/raffle',
        primaryLabel: 'Enter Raffles',
        secondaryLink: '/client/raffle/winners',
        secondaryLabel: 'Winners Podium',
    },
    {
        title: 'Quiz & Trivia',
        description:
            'Challenge your knowledge with quick daily quizzes, earn bonus coins and rank up.',
        icon: 'lucideHelpCircle',
        primaryLink: '/quiz',
        primaryLabel: 'Play Daily Quizzes',
        secondaryLink: '/quiz',
        secondaryLabel: 'Rules & Rewards',
    },
]
